/** @format */

export enum CdnNames {
	DksCdn = 0,
	GolfGalaxy = 1,
	DksFed = 2,
	GolfGalaxyTest = 3
}
